import React from 'react';
import { Row, Col, Headline, Paragraph, List, Icon, BackgroundImage, Button } from 'View/Common';
import { colors } from 'View/Theme';
import { useAudioPlayerModal } from 'View/HookApi/useAudioPlayerModal';
import { AudioPlayerModal } from 'View/Component';
import { audioDeinSchlaf, audipPlayerHG } from 'img/SleepPage';
import Style from './AudioSampleItems.style';
import { AudioSampleItemsConfig, AudioSampleVariant } from './AudioSampleItemsConfig';

type SampleProps = {
  audioId: string;
  variant: AudioSampleVariant;
};

export const AudioSampleItems: React.FC<SampleProps> = ({ audioId, variant }) => {
  const modalProps = useAudioPlayerModal(audioId);
  const { image, headline, description, listItems, buttonTitle } = AudioSampleItemsConfig[variant];

  const audio = audioDeinSchlaf;
  const courseImage = audipPlayerHG;

  return (
    <Style>
      <Row className="sleep-sample-row">
        <Col xs={12} md={6} lg={6} className="image-wrapper">
          <BackgroundImage image={image} className="slider-image" />
        </Col>

        <Col xs={12} md={6} lg={6} className="content-wrapper">
          <Headline level={2}>{headline}</Headline>
          <Paragraph>{description}</Paragraph>

          <List
            className="description-list"
            icon={<Icon color={colors.sleep.beige.c100} name="Checkmark" size={{ sm: 32, md: 32, lg: 40 }} />}
          >
            {listItems.map((text, idx) => (
              <Paragraph key={`li-${idx + 1}`}>{text}</Paragraph>
            ))}
          </List>

          <AudioPlayerModal
            audioId={audioId}
            toggle={modalProps.toggle}
            isOpen={modalProps.isOpen}
            courseAudio={audio}
            courseImage={courseImage}
            onClose={modalProps.closeModalAfterAudioPlayed}
          />

          <Button className="cta-button" title={buttonTitle} onClick={modalProps.toggle}>
            <Icon color={colors.sleep.beige.c100} name="Play" size={{ sm: 32, md: 32, lg: 32 }} />
            Hörprobe
          </Button>
        </Col>
      </Row>
    </Style>
  );
};

type WrapperProps = { audioId: string };

export const AudioSampleCourse: React.FC<WrapperProps> = (props) => <AudioSampleItems {...props} variant="course" />;

export const AudioSampleSleepAids: React.FC<WrapperProps> = (props) => <AudioSampleItems {...props} variant="sleepAids" />;

export const AudioSampleLogbook: React.FC<WrapperProps> = (props) => <AudioSampleItems {...props} variant="logbook" />;
